import { render, staticRenderFns } from "./PageDocProductionsAide.vue?vue&type=template&id=3a9eff2a&"
import script from "./PageDocProductionsAide.vue?vue&type=script&lang=js&"
export * from "./PageDocProductionsAide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports